<template>
  <div>
    <b-modal
      title="Endurstilla umsókn"
      size="lg"
      lazy
      :no-close-on-backdrop="true"
      ok-title="Endurstilla"
      cancel-title="Hætta við"
      @ok.prevent="validateBeforeSubmit"
      :ok-disabled="loading || hasBlockers || !acknowledged"
      ref="createModal"
    >
      <div v-if="loading" class="text-center py-3">
        <b-spinner />
      </div>

      <div v-else>
        <b-alert variant="danger" :show="hasBlockers">
          <strong>Ekki er hægt að endurstilla: viðveruskráning er til staðar</strong>
          <ul class="mb-0 mt-2">
            <li v-for="b in blockers" :key="b.pgpId">{{ b.personName }}, {{ b.placementGroupName }}</li>
          </ul>
          <div class="mt-2 small">Eyða þarf viðveruskráningu áður en hægt er að endurstilla.</div>
        </b-alert>

        <template v-if="!hasBlockers">
          <b-alert variant="warning" show>
            Þetta eyðir öllum hópaskráningum og setur umsóknina aftur á Nýskráð. Aðgerðin er rekjanleg en óafturkræf.
            <div class="mt-2 small">
              Athugið: bankareikningur, netfang, farsími og sérþarfir sem hefur verið breytt á þátttakandaspjaldi tapast og verða
              endurafrituð úr umsókninni þegar hún er samþykkt aftur.
            </div>
          </b-alert>

          <div v-if="placementsToDelete.length" class="mb-3">
            <strong>Hópaskráningar sem verða eytt ({{ placementsToDelete.length }}):</strong>
            <ul class="mt-1 mb-0">
              <li v-for="p in placementsToDelete" :key="p.id">{{ p.placementGroupName }}</li>
            </ul>
          </div>

          <div v-if="periodParts.length" class="mb-3">
            <strong>Starfstímabil sem verða sett á Nýskráð:</strong>
            <ul class="mt-1 mb-0">
              <li v-for="pp in periodParts" :key="pp.id">{{ pp.periodPartName }}</li>
            </ul>
          </div>

          <b-form-checkbox v-model="acknowledged" class="mt-3">
            Ég skil að þessi aðgerð eyðir hópaskráningum og er óafturkræf
          </b-form-checkbox>
        </template>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'application-reset-full-modal',
  data() {
    return {
      loading: false,
      application: null,
      hasBlockers: false,
      blockers: [],
      placementsToDelete: [],
      periodParts: [],
      acknowledged: false,
    };
  },
  methods: {
    async show(application) {
      this.application = application;
      this.hasBlockers = false;
      this.blockers = [];
      this.placementsToDelete = [];
      this.periodParts = [];
      this.acknowledged = false;
      this.$refs.createModal.show();
      await this.loadPrecheck();
    },
    async loadPrecheck() {
      this.loading = true;
      try {
        const response = await this.$applicationApi.applicationResetPrecheckRetrieve(
          { uuid: this.application.id },
          { params: { scope: 'full' } },
        );
        const d = response.data;
        this.hasBlockers = d.hasBlockers;
        this.blockers = d.blockers || [];
        this.placementsToDelete = d.placementsToDelete || [];
        this.periodParts = d.periodParts || [];
      } catch (e) {
        this.displayError('Óvænt villa kom upp við forprófun. Vinsamlegast reyndu aftur.');
      } finally {
        this.loading = false;
      }
    },
    async validateBeforeSubmit() {
      this.loading = true;
      try {
        await this.$applicationApi.applicationResetFullCreate({ uuid: this.application.id });
        this.displaySuccess('Umsókn endurstillt á Nýskráð');
        this.$emit('successful', {});
        this.$refs.createModal.hide();
      } catch (e) {
        if (e.response && e.response.status === 409) {
          this.hasBlockers = true;
          this.blockers = e.response.data.blockers || [];
          this.acknowledged = false;
        } else {
          this.displayError(`Óvænt villa (${e.response ? e.response.status : -1}) kom upp. Vinsamlegast reyndu aftur.`);
        }
      } finally {
        this.loading = false;
      }
    },
    ...mapActions({
      displayError: 'displayError',
      displaySuccess: 'displaySuccess',
    }),
  },
};
</script>
